<template>
  <v-card class="mb-4" flat :loading="loadingItem">
    <validation-observer ref="obs" v-slot="{ invalid }">
      <v-card-text>
        <v-row v-if="!loadingItem">
          <v-col cols="4">
            <audio
              controls  
              :src="audioContent"
            >
            
          </audio>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="
            !item.audio ||
            loadingItem ||
            updatingItem ||
            deletingItem ||
            invalid
          "
          :loading="deletingItem"
          @click="updateItem('delete')"
          text
        >
          {{ $t("delete") }}
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="item.saved"
          color="primary"
          :disabled="
            !item.audio ||
            loadingItem ||
            updatingItem ||
            deletingItem ||
            invalid
          "
          :loading="updatingItem"
          @click="updateItem('dearchive')"
          text
        >
          {{ $t("unsave") }}
        </v-btn>
        <v-btn
          v-else
          color="primary"
          :disabled="
            !item.audio ||
            loadingItem ||
            updatingItem ||
            deletingItem ||
            invalid
          "
          :loading="updatingItem"
          @click="updateItem('archive')"
          text
        >
          {{ $t("save") }}
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import showErrors from "@/utils/mixins/showErrors";
import isMobile from "@/utils/mixins/isMobile";

export default {
  name: "VoiceMail",
  mixins: [showErrors, isMobile],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    item: {},
    itemId: null,
    productId: null,
    numberId: null,
    loadingItem: false,
    updatingItem: false,
    deletingItem: false,
  }),
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          this.productId = value.product_id;
          this.numberId = value.number_id;
          this.itemId = value.id;
          this.getItem();
        }
      },
    },
  },
  computed: {
    audioType() {
      return this.item.audio ? this.item.audio.content_type : null;
    },
    audioContent() {
      return this.item.audio ? ('data:' + this.audioType + ';base64,' + this.item.audio.content) : null;
    },
    audioSize() {
      return this.item.audio ? 1 : null;
    },
  },
  methods: {
    getItem() {
      var that = this;
      that.loadingItem = true;
      this.$http
        .get(
          "services/voip/" +
            this.productId +
            "/numbers/" +
            this.numberId +
            "/voice-mails/" +
            this.itemId
        )
        .then((response) => {
          that.item = response.data;
        })
        .catch((err) => {
          that.$store.commit("setSystemError", {
            msg: err.message,
            title: err.title,
          });
        })
        .finally(function () {
          that.loadingItem = false;
        });
    },
    updateItem(action) {
      var that = this;
      if (action == "delete") this.deletingItem = true;
      else this.updatingItem = true;
      this.$http
        .patch(
          "services/voip/" +
            this.productId +
            "/numbers/" +
            this.numberId +
            "/voice-mails/" +
            this.itemId,
          action == "delete"
            ? { deleted: true }
            : action == "archive"
            ? { saved: true }
            : { saved: false }
        )
        .then((response) => {
          that.item = response.data;
          if (action == "delete") that.$emit("deleted", that.item);
          else that.$emit("updated", that.item);
        })
        .catch((err) => {
          that.$store.commit("setSystemError", {
            msg: err.message,
            title: err.title,
          });
        })
        .finally(function () {
          that.updatingItem = false;
          that.deletingItem = false;
        });
    },
  },
};
</script>

<i18n>
{
  "en": {
    "name": "Name",
    "number": "Number",
    "time start": "Time start",
    "time played": "Time played",
    "duration": "Duration",
    "saved": "Archived",
    "static": "Static",
    "greeting": "Greeting",
    "music on hold": "Music on hold",
    "unlocked": "Unlocked",
    "deleted": "Deleted",
    "save": "Archive",
    "unsave": "Dearchive",
    "delete": "delete",
    "audio upload": "Audio upload"
  },
  "de": {
    "name": "Name",
    "number": "Number",
    "time start": "Time start",
    "time played": "Time played",
    "duration": "Duration",
    "saved": "Archiviert",
    "static": "Static",
    "greeting": "Greeting",
    "music on hold": "Music on hold",
    "unlocked": "Unlocked",
    "deleted": "Deleted",
    "save": "Archivieren",
    "unsave": "Dearchivieren",
    "delete": "Löschen",
    "audio upload": "Audio upload"
  }
}
</i18n>
